let Theme = {
    THEME_LOCAL_STORAGE: 'isDarkTheme',
    TOGGLE_THEME: 'TOGGLE_THEME',
};

export default Theme;
